import * as Styled from './styled';
import { Stack } from '@/ui/primatives';

const SelectCellCta: React.FC<{}> = ({}) => {
  return (
    <Styled.SelectCellCta>
      <Stack gap={10} alignItems="center">
        <table>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td className="selected"></td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div>Select a cell to see row details</div>
      </Stack>
    </Styled.SelectCellCta>
  );
};

export default SelectCellCta;
